module.exports = __webpack_public_path__ + "img/translate_icon.4386a7ab.svg";